import { __awaiter, __generator } from "tslib";
import { InteractionType, PairwiseBrokerApplication, } from '@azure/msal-browser-1p';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchFeatureSettings } from '@office-start/feature-settings-service';
import { fetchIdentity } from '@office-start/identity-service';
var initializePromise;
var msalClient;
// This is meant to be used only to initialize pair wise token brokering with MSAL. It does not initialize MSAL for token fetching
// for our application (it doesn't not do SPA auth code initialization), so no refresh token is stored in our local storage cache.
// DIME fetches token using pair wise brokering for their app end-to-end, remove it once Pairwise brokering is merged with MSAL PublicClientApplication
export function initializePairwiseBroker() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (initializePromise) {
                return [2 /*return*/, initializePromise];
            }
            initializePromise = fetchFeatureGates().then(function (gates) {
                var _a;
                if (!((_a = gates.result.dimeBrokerGates) === null || _a === void 0 ? void 0 : _a.dimeBrokerEnabled)) {
                    return Promise.resolve(null);
                }
                return fetchFeatureSettings().then(function (settings) {
                    return fetchIdentity().then(function (identity) {
                        var _a;
                        var authOptions = settings.result.authOptions;
                        msalClient = new PairwiseBrokerApplication({
                            auth: {
                                clientId: (_a = authOptions === null || authOptions === void 0 ? void 0 : authOptions.aadAppId) !== null && _a !== void 0 ? _a : '',
                                redirectUri: "https://".concat(window.location.host).concat(authOptions === null || authOptions === void 0 ? void 0 : authOptions.spaRedirectUrlPath),
                                authority: (authOptions === null || authOptions === void 0 ? void 0 : authOptions.aadAuthorityUrlRoot) +
                                    "/".concat(identity.tenantId),
                            },
                            cache: {
                                cacheLocation: 'localStorage',
                                claimsBasedCachingEnabled: true,
                            },
                        }, {
                            actAsBroker: true,
                            preferredInteractionType: InteractionType.Popup,
                        });
                        return msalClient.initializeBrokering().then(function () {
                            return msalClient;
                        });
                    });
                });
            });
            return [2 /*return*/, initializePromise];
        });
    });
}
//# sourceMappingURL=initializePairwiseBroker.js.map